<template>
  <div>
    <b-jumbotron
      v-if="card && showOldCard"
      bg-variant="dark"
      text-variant="secondary test"
      class="my-4 py-2 px-3"
    >
      <p class="text-left">
        <small>PAYMENT METHOD:</small>
        <small class="float-right">
          <b-link href="#" @click="showOldCard = false">
            <small> + Add New Card </small>
          </b-link>
        </small>
      </p>
      <p class="text-light">
        <b-icon-credit-card class="mr-2" />
        <strong class="text-capitalize">{{ card.brand }}</strong> Ending in
        <strong>{{ card.last4 }}</strong>
      </p>

      <b-button
        size="sm"
        class="radius-10 my-3 py-2 w-100"
        :variant="type === 'vip' ? `gold light` : `primary`"
        @click="$emit('complete')"
      >
        <span v-if="type === 'vip'">Continue Subscribe</span>
        <span v-else v-text="`Continue ` + type" />
      </b-button>
    </b-jumbotron>

    <b-jumbotron
      v-else
      bg-variant="dark"
      text-variant="secondary"
      class="my-4 py-2 px-3"
    >
      <p class="text-left">
        <small>PAYMENT METHOD:</small>
        <small class="float-right" v-if="card">
          <b-icon-x-circle
            class="cursor"
            @click="
              ;(showOldCard = true), (stripeError = null), (complete = false)
            "
          />
        </small>
      </p>
      <card
        class="stripe-card"
        :class="{ complete }"
        :stripe="stripeKey"
        :options="stripeOptions"
        @change=";(complete = $event.complete), (stripeError = null)"
      />
      <b-button
        variant="primary"
        size="sm"
        class="radius-10 my-3 py-2 w-100"
        :disabled="!complete"
        @click="addCard"
      >
        <b-spinner small v-if="loading" />

        <span> Add Card</span>
      </b-button>
      <small class="text-warning" v-if="stripeError">
        {{ stripeError }}
      </small>
    </b-jumbotron>

    <small class="float-left cursor mt-1" @click="$emit('cancel')">
      <b-icon-arrow-left />
      <small> back</small>
    </small>

    <b-img
      src="~@/assets/img/powered-by-stripe.png"
      height="25px"
      class="float-right"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { Card, createPaymentMethod } from 'vue-stripe-elements-plus'

export default {
  name: 'AddCard',
  props: ['type'],
  components: { Card },

  data() {
    return {
      showOldCard: true,
      complete: false,
      loading: false,
      stripeKey: '',
      stripeOptions: {
        style: {
          base: {
            fontSize: '16px',
          },
        },
      },
      stripeError: null,
    }
  },

  computed: {
    ...mapState({
      card: (state) => state.auth.card,
      errorMessage: (state) => state.auth.errorMessage,
    }),
  },

  methods: {
    ...mapActions({
      attachCard: 'auth/attachCard',
    }),
    ...mapMutations({
      handleError: 'auth/handleError',
    }),

    addCard() {
      this.loading = true

      createPaymentMethod('card').then((data) => {
        if (data.error) {
          this.stripeError = data.error.message
        } else if (data.paymentMethod) {
          this.attachPaymentCard(data.paymentMethod.id)
        }

        this.loading = false
      })
    },

    async attachPaymentCard(id) {
      this.handleError(null)
      this.loading = true

      await this.attachCard({
        payment_method_id: id,
      })

      this.stripeError = this.errorMessage

      if (!this.stripeError) {
        this.showOldCard = true
      }

      this.loading = false
    },
  },

  created() {
    this.stripeKey = process.env.VUE_APP_STRIPE_KEY
  },
}
</script>

<style scoped></style>
